import React, { useEffect, useState } from 'react'
import Upcoming from './Components/Upcoming';
import moment from 'moment';
import Loader from '../../components/Atoms/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import {coinManagementActions, kycVerificationListActions } from '../../_actions';
import Nodata from '../../components/Atoms/NoData/NoData';
import HeadingButtonForUpcomingId from '../../components/Atoms/KycComponent/HeadingButtonForUpcomingId';
import ViewHistoryModal from '../../components/Atoms/popup/ViewHistoryModal';
import Pagination from '../../components/Pagination/Pagination';
// import ActionPopup from '../../components/Atoms/ActionPopup/ActionPopup';
const size = 5
const sortBy = 'createdAt'
const sortOrder = 'desc'

const UpcomingIdExpires = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get('tab');
    const selector = useSelector(state => state)
    const [kycList, setKycList] = useState([])
    const [kycList2, setKycList2] = useState([])

    const [pageNo, setPageNo] = useState(1)
    // const [showActionPopup, setShowActionPopup] = useState(false);
    const [activeButton, setActiveButton] = useState(tabParam || 'upcoming');
    const [activeContent, setActiveContent] = useState(tabParam || 'upcoming');
    // const [error, setError] = useState('');
    // const [selectedData, setSelectedData] = useState({
    //     status: "",
    //     kycId: "", rejectionReason: ""
    // });
    const [count, setCount] = useState([])
    const [isViewModal, setIsViewModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)


    // console.log(selector?.kyc)



    function getCountList() {
        coinManagementActions.getAmountAndCount({ type: "UPCOMING_ID_EXPIRES" }).then((res) => {
            if (res) {
                setCount(res?.data)
            }
        }).catch((err) => console.log(err))
    }
    useEffect(() => {
        getCountList()
    }, []);


    const updateUrlParams = (tab, page) => {
        const params = new URLSearchParams();
        params.set('tab', tab);

        navigate({
            pathname: location.pathname,
            search: params.toString()
        });
    };
    useEffect(() => {
        updateUrlParams(activeButton);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeButton]);

    const details = {
        sortOrder,
        sortBy,
        pageNo,
        size: size,
        type: activeContent
    };

    useEffect(() => {
        setIsLoading(true)
        dispatch(kycVerificationListActions.kycExpiresList(details))
        setIsLoading(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, sortOrder, sortBy, pageNo, size, activeContent]);

    useEffect(() => {
        setKycList(selector?.kyc?.merchantKycExpireList)
    }, [selector]);

    // const handleStatusChange = (status, kycId) => {
    //     const reqData = { status, kycId }
    //     if (status !== "approved") {
    //         reqData.notes = ""
    //     }
    //     setSelectedData(reqData);
    //     setShowActionPopup(true);
    // };

    const handleContentChange = (content) => {
        setActiveContent(content);
    };

    const getStatusDetails = (content) => {
        switch (content) {
            case 'upcoming':
                return { statusTitle: 'Upcoming', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
            case 'expired':
                return { statusTitle: 'Expired', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
            default:
                return { statusTitle: 'Pending', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
        }
    };

    const onPageChange = page => {
        setPageNo(page)
    }

    const handleButtonClick = (content) => {
        setActiveButton(content);
        handleContentChange(content);
        setPageNo(1)
    };



    // const handleConfirm = () => {
    //     let errors = {};
    //     if ((selectedData?.status === "rejected" || selectedData?.status === "more-info") && !selectedData?.rejectionReason?.trim()) {
    //         errors.inputValue = "Please provide a reason.";
    //     }
    //     if (Object.keys(errors).length > 0) {
    //         setError(errors);
    //         return;
    //     }
    //     const payload = {
    //         kycId: selectedData?.kycId,
    //         notes: selectedData?.rejectionReason,
    //         status: selectedData?.status
    //     }
    //     setIsLoading(true)
    //     kycVerificationListActions
    //         .updateKycStatus(payload)
    //         .then((response) => {
    //             if (response) {
    //                 dispatch(kycVerificationListActions?.kycVerificationList(details));
    //                 dispatch(alertActions.success(response?.message || "Success."));
    //                 getCountList()
    //                 setSelectedData({
    //                     status: "",
    //                     kycId: "",
    //                     rejectionReason: "",
    //                 });
    //                 setError({});
    //                 setIsLoading(false)

    //             }
    //         })
    //         .catch((err) => {
    //             dispatch(alertActions.error(err));
    //         });

    //     setShowActionPopup(false);
    // };


    // const handleClose = () => {
    //     setShowActionPopup(false)
    //     setSelectedData({
    //         status: "",
    //         kycId: "",
    //     })
    // }

    const { statusTitle, updatedStatusDate } = getStatusDetails(activeContent);

    const handleViewAction = async (data) => {
        try {
            setIsViewModal(true);
            setIsLoading(true)
            const response = await kycVerificationListActions.viewRejectionsReasonsForKyc({ id: data });
            if (response?.data) {
                setKycList2(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch KYC rejection reasons:", error);
        } finally {
            setIsLoading(false)
        }
    };

    return (
        <>
            <Loader loading={selector?.kyc?.loading || isLoading} />
            <div className="p-6 space-y-2 overflow-hidden overflow-y-auto bg-gray-50">
                <HeadingButtonForUpcomingId
                    Heading={`Upcoming Id Expired`}
                    activeContent={activeContent}
                    upcomingCount={count?.upcoming}
                    expireCount={count?.expired}
                    handleButtonClick={handleButtonClick}
                    activeButton={activeButton}
                />
                {activeButton === 'upcoming' && (
                    kycList && kycList.length > 0 ? (
                        kycList.map((ele, idx) => (
                            <div className='space-y-3' key={idx}>
                                <Upcoming
                                    profileUrl={ele?.liveSelfie}
                                    userIdName={ele?.userId?.name}
                                    kycCreatedDate={moment(ele?.createdAt).format('ll')}
                                    userKycEmail={ele?.userId?.email}
                                    kycCountry={ele?.countryCode?.name}
                                    kycDcoOne={ele?.identificationDocuments?.documentFrontImage}
                                    kycDocTwo={ele?.identificationDocuments?.documentBackImage}
                                    kycDocNumber={ele?.identificationDocuments?.documentNumber}
                                    kycDocDate2={moment(ele?.identificationDocuments?.documentExpiration).format("DD/MM/YYYY")}
                                    kycAddressDoc={ele?.addressProof?.documentImage}
                                    kycAddressProofDocumentName={ele?.addressProof?.documentName}
                                    statusTitle={statusTitle}
                                    updatedStatusDate={updatedStatusDate}
                                    // handleReject={() => handleStatusChange("rejected", ele._id)}
                                    // handleApprove={() => handleStatusChange("approved", ele._id)}
                                    // handleMoreInfo={() => handleStatusChange("more-info", ele._id)}
                                    verifiedBy={ele?.verifiedBy}
                                    id={ele?._id}
                                    handleAction={handleViewAction}
                                    date={ele?.updatedAt}
                                />
                            </div>
                        ))
                    ) : (
                        <div className='mt-2 border border-gray-300 rounded-md'>
                            <Nodata
                                nodataLabel="No Data found"
                                nodataDesc="There are no Data to display"
                            />
                        </div>
                    )
                )}




                {activeButton === 'expired' ? (
                    kycList && kycList.length > 0 ?
                        kycList.map((ele, idx) => (
                            <div className='space-y-3' key={idx}>
                                <Upcoming
                                    profileUrl={ele?.liveSelfie}
                                    userIdName={ele?.userId?.name}
                                    kycCreatedDate={moment(ele?.createdAt).format('ll')}
                                    userKycEmail={ele?.userId?.email}
                                    kycCountry={ele?.countryCode?.name}
                                    kycDcoOne={ele?.identificationDocuments?.documentFrontImage}
                                    kycDocTwo={ele?.identificationDocuments?.documentFrontImage}
                                    kycDocNumber={ele?.identificationDocuments?.documentNumber}
                                    kycDocDate2={moment(ele?.identificationDocuments?.documentExpiration).format("DD/MM/YYYY")}
                                    kycAddressDoc={ele?.addressProof?.documentImage}
                                    kycAddressProofDocumentName={ele?.addressProof?.documentName}
                                    statusTitle={statusTitle}
                                    updatedStatusDate={updatedStatusDate}
                                    verifiedBy={ele?.verifiedBy}
                                    id={ele?._id}
                                    handleAction={handleViewAction}
                                    date={ele?.updatedAt}
                                />
                            </div>
                        ))
                        : <div className='mt-2 border border-gray-300 rounded-md'>
                            <Nodata
                                nodataLabel={"No Data found"}
                                nodataDesc={"There are no Data to display"}
                            />
                        </div>
                ) : null}









            </div>

          

            {Math.ceil(selector?.kyc?.merchantKycExpireListTotal / size) > 1 && (
                <Pagination
                    totalPages={Math.ceil(selector?.kyc?.merchantKycExpireListTotal / size)}
                    currentPage={pageNo}
                    onPageChange={onPageChange} />
            )}

            <ViewHistoryModal
                isOpen={isViewModal}
                onClose={() => setIsViewModal(false)}
                heading="History"
                data={kycList2}
                isNotesData={false}
                isApiResData={true}

            />
        </>
    )
}

export default UpcomingIdExpires